import { render, staticRenderFns } from "./CarouselChevron.vue?vue&type=template&id=3b309d7f&"
import script from "./CarouselChevron.vue?vue&type=script&lang=js&"
export * from "./CarouselChevron.vue?vue&type=script&lang=js&"
import style0 from "./CarouselChevron.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports